import { Box, SelectChangeEvent, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { MultiSelect } from "../multi_select";

export const SegmentSelect = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  segments: string[];
  setSegments: (segments: string[]) => void;
  columns: { name: string; caption: string }[];
}) => {
  const { isLoading, sx, segments, setSegments, columns } = props;

  return (
    <Box sx={sx}>
      <Box sx={{ fontSize: 11 }}>Segment by</Box>
      <MultiSelect
        disabledDeleteValue={"table_id"}
        isLoading={isLoading}
        selectedOptions={segments}
        handleChange={async (event: SelectChangeEvent<string[]>) => {
          const selectedValues = Array.isArray(event.target.value)
            ? event.target.value
            : [event.target.value];
          setSegments(selectedValues);
        }}
        handleDelete={async (segment: string) => {
          const newSegments = segments.filter((s) => s !== segment);
          setSegments(newSegments);
        }}
        // TODO: we should use the caption instead of the name
        options={columns.map((c) => c.name)}
      ></MultiSelect>
    </Box>
  );
};
